export default __webpack_public_path__ + "static/media/footer-searchlocation-icon.e551fa2b.svg";